import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import CampoSenha from '../componentes/CampoSenha'
import CartaoErro from '../componentes/CartaoErro'

export default function Login() {
  const { entrar } = useAuth()
  const navegar = useNavigate()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  async function aoEnviar(e: FormEvent) {
    e.preventDefault()
    setEnviando(true)
    setErro(null)
    const mensagem = await entrar(email, senha)
    setEnviando(false)
    if (mensagem) setErro(mensagem)
    else navegar('/')
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <form onSubmit={aoEnviar} className="w-full max-w-sm bg-white rounded-xl shadow-sm p-6 space-y-4">
        {/* Logo inteiro dela (04/10) na entrada; o icone do app leva so o recorte. */}
        <img src="/logo-completo.png" alt="" width={160} height={160} className="mx-auto w-40 h-40 rounded-3xl" />
        <h1 className="sr-only">CRM Multimarca</h1>
        <div>
          <label htmlFor="email" className="block text-sm text-slate-600 mb-1">E-mail</label>
          <input
            id="email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-3 py-2"
          />
        </div>
        <CampoSenha
          id="senha"
          rotulo="Senha"
          valor={senha}
          aoMudar={setSenha}
          autoComplete="current-password"
        />
        {erro && <CartaoErro titulo="Não foi possível entrar">{erro}</CartaoErro>}
        <button
          type="submit" disabled={enviando}
          className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium disabled:opacity-50"
        >
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
        <p className="text-sm text-center">
          <Link to="/esqueci-senha" className="text-teal-700 underline">Esqueci minha senha</Link>
        </p>
        <p className="text-sm text-slate-600">
          {/* Desde 15/10 a conta nasce da compra na Hotmart (cadastro aberto desligado). */}
          Ainda não é assinante?{' '}
          <a href="https://crmeunegocio.com.br/" className="text-teal-700 underline">Conheça o CRM Multimarca</a>
        </p>
      </form>
    </main>
  )
}
